import { useProPilotLifecycleActions } from "PFApp/stores/propilot_lifecycle_store";
import { useFloatingPositionStoreActions } from "PFComponents/floating_expandable_bubble/floating_position_store";
import { useCallback } from "react";

import { BUBBLE_POSITION_STORAGE_KEY, PROPILOT_DEFAULT_POSITION } from "../constants";

export const useDockAndResetPosition = () => {
  const { dock } = useProPilotLifecycleActions();
  const { setPosition } = useFloatingPositionStoreActions();

  return useCallback(() => {
    dock();
    setPosition(BUBBLE_POSITION_STORAGE_KEY, PROPILOT_DEFAULT_POSITION);
  }, [dock, setPosition]);
};
